import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConfigOption {
  readonly name: string;
  readonly value: string;
}

interface SelectCaptureConfigProps {
  type: string;
  configurationSelect: string;
  setConfigurationSelect: (value: string) => void;
}

function SelectCaptureConfig({
  type,
  configurationSelect,
  setConfigurationSelect,
}: SelectCaptureConfigProps): React.ReactElement {
  const { t } = useTranslation('provider');

  const configOptions: readonly ConfigOption[] = [
    {
      name: 'SkyWatch Standard',
      value: 'SkyWatch Standard',
    },
    {
      name: 'Alternate Configurations',
      value: 'Alternate Configurations',
    },
  ] as const;

  const handleConfigChange = (event: SelectChangeEvent<string>): void => {
    setConfigurationSelect(event.target.value);
  };

  return (
    <Box display="flex" gap={3} flexDirection="column">
      <FormControl variant="filled" fullWidth>
        <InputLabel id="capture-method-label">{t('captureMethod')}</InputLabel>
        <Select
          readOnly
          labelId="capture-method-label"
          id="capture-method-select"
          label={t('captureMethod')}
          value={type}
          MenuProps={{
            className: 'select-menu',
          }}
        >
          <MenuItem value={type}>{type}</MenuItem>
        </Select>
      </FormControl>
      <FormControl variant="filled" fullWidth>
        <InputLabel id="configuration-label">{t('configurations')}</InputLabel>
        <Select
          labelId="configuration-label"
          id="configuration-select"
          label={t('configurations')}
          value={configurationSelect}
          MenuProps={{
            className: 'select-menu',
          }}
          onChange={handleConfigChange}
        >
          {configOptions?.map((item: ConfigOption) => (
            <MenuItem key={item?.value} value={item?.value}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default SelectCaptureConfig;
